module.exports = __webpack_public_path__ + "static/img/html-logo.fed4481b.svg";